import { TrackerTag } from '@/types/tracking';
import { useEffect, useRef } from 'react';
import { addtracking } from '../redux/features/tracking';
import { AttributionTrackingTags } from './constants';

export type asyncTrackingEventProps = {
  track?: string;
  trackAbacus?: string;
  trackId?: string;
  trackText?: any;
  trackUrl?: any;
  trackTarget?: string;
  trackValue?: any;
  trackMeta?: object;
};

/**
 * asycTrackingEvent
 * @param data tracking data
 */
export const asyncTrackingEvent = (data: asyncTrackingEventProps) => {
  const event = new CustomEvent('asyncTrackingEvent', { detail: data });
  // process.env.NODE_ENV == 'development' && console.debug('asyncTrackingEvent', event);
  window.dispatchEvent(event);
};

/**
 * asyncVirtualPageViewEvent
 * @param data tracking data
 */
export const asyncVirtualPageViewEvent = (data: asyncTrackingEventProps) => {
  data.track = 'virtual_pageview';
  data.trackAbacus = 'virtual_pageview';
  const event = new CustomEvent('asyncTrackingEvent', { detail: data });
  // process.env.NODE_ENV == 'development' && console.debug('asyncVirtualPageViewEvent', event);
  window.dispatchEvent(event);
};

/**
 * aysncPageLoadEvent
 * Used when you want to fire an event off on page load.
 * @param location  react location object
 * @param data tracking data
 * @returns
 */
export const asyncPageLoadEvent = (location: any, data: asyncTrackingEventProps, changes: any = []) => {
  const locationRef = useRef({
    location: null
  });
  useEffect(() => {
    if (!locationRef.current.location) {
      locationRef.current.location = location;
      setTimeout(() => asyncTrackingEvent(data), 250);
    }
  }, changes);
  return locationRef;
};

export const initializeAttributionTracking = (location: any, dispatch: any) => {
  const params = new URLSearchParams(location.search);
  if (params.size > 0) {
    const tracking = AttributionTrackingTags.forEach((trackingTag: TrackerTag) => {
      trackingTag.tags.forEach((tag: string) => {
        const tagValue = params.get(tag);
        if (tagValue) {
          dispatch(
            addtracking({
              value: tagValue,
              source: location.pathname,
              ...trackingTag
            })
          );
        }
      });
    });
  }
};
